module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, [_c('div', {
    staticClass: "sidebar-menu"
  }, [(this.user1.roleName == 'Super Admin') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n      Masters")]) : _vm._e(), _vm._v(" "), (this.user1.roleName == 'Super Admin') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/users"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Users")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9ea3436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/main/SidebarMenu.vue
// module id = 2016
// module chunks = 1